import { clients } from "./clients";
import { eventReports } from "./event-reports";

export const event = {
	clients,
	...eventReports,
};
